import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../types";
import { HeaderData } from "../../../../types/webCms/header";

// get all
export const getAllHeaderDataAsync = createAsyncThunk<
  GetCommonData<HeaderData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllHeaderData", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getHomeHeader);

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get data fail");
    return rejectWithValue(error);
  }
});

// update
export const updateHeaderDataAsync = createAsyncThunk<
  null,
  PostRequest<HeaderData, any>
>(
  "admin/updateHeaderData",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateHomeHeader}`, data, {
        headers: {},
      });

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "update fail");
      return rejectWithValue(error);
    }
  }
);
